<template>
    <div>
        <el-form @submit.native.prevent="onSubmitExclusao" :model="dados" ref="dados" label-position="top">
            <el-row :gutter="10" class="">
                <el-col :xs="24" :sm="16" :md="16">
                    <dl>
                        <dt>NOME</dt>
                        <dd>
                            {{ aluno.nome }}
                        </dd>
                    </dl>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <dl>
                        <dt>Nr. MATRÍCULA</dt>
                        <dd>
                            {{ (aluno.num_matricula) ? aluno.num_matricula : '-' }}
                        </dd>
                    </dl>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="">
                <el-col :xs="24" :sm="8" :md="8">
                    <dl>
                        <dt>Dt. NASCIMENTO</dt>
                        <dd>
                            {{ (aluno.data_nascimento) ? $moment(aluno.data_nascimento).format('DD/MM/YYYY') : '-' }}
                        </dd>
                    </dl>
                </el-col>
                <el-col :xs="24" :sm="16" :md="16">
                    <dl>
                        <dt>FILIAÇÃO 1</dt>
                        <dd>
                            {{ aluno.mae }}
                        </dd>
                    </dl>
                </el-col>                
            </el-row>
            <el-row :gutter="10" class="u-mt-30">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Ação" prop="acao" :rules="[$requiredChange]" key="acao">
                        <el-select v-model="dados.acao" clearable>
                            <el-option :key="1" label="EXCLUIR" :value="1"></el-option>
                            <el-option :key="2" label="UNIFICAR" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>            
            <el-row :gutter="10" v-if="dados.acao == 2">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Matrícula" prop="matricula_unificacao" :rules="[$requiredBlur]" key="matricula_unificacao">
                        <el-input v-model="dados.matricula_unificacao" maxlength="191"></el-input>
                    </el-form-item>
                </el-col>                
            </el-row>
            
            <el-row :gutter="10" v-if="dados.acao">
                <el-col :xs="24" :sm="18" :md="18" v-if="dados.acao == 2">
                    <i>Informe o número da matrícula do aluno que receberá as matrículas do aluno excluído.</i>
                </el-col>
                <el-col :xs="24" :sm="dados.acao == 2 ? 6 : 24" :md="dados.acao == 2 ? 6 : 24">
                    <el-form-item class="u-text-right">
                        <el-button type="primary" id="btn-modelo" native-type="submit">{{ dados.acao == 1 ? 'EXCLUIR' : 'UNIFICAR' }}</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>


export default {
    props: ['aluno'],
    data: () => ({
        step: 0,
        dados:{ 
            aluno_id: '',
            matricula: '',
            acao: '',
            matricula_unificacao: '',
            
        }
    }),
    mounted(){

        this.dados.aluno_id = this.aluno.id;
        this.dados.matricula = this.aluno.num_matricula;
    },
    methods:{
        onSubmitExclusao(){

            this.$refs.dados.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/unificarAluno`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                    
                    if(typeof response.data.erro !== 'undefined'){

                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('closeModal');
                    }                    

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        }
    },
    components:{ }
}
</script>
